export default __webpack_public_path__ + "static/media/sent-email.a42e173c.svg";